import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";

export default function AnimatedList({ 
    items, 
    renderItem, 
    keyExtractor,
    className 
}) {
    const [exitingItems, setExitingItems] = useState([]);
    
    // Track items that are being removed
    useEffect(() => {
        const currentKeys = new Set(items.map(keyExtractor));
        setExitingItems(prev => prev.filter(item => !currentKeys.has(keyExtractor(item))));
    }, [items, keyExtractor]);

    return (
        <div className={className}>
            <AnimatePresence mode="popLayout">
                {items.map(item => (
                    <motion.div
                        key={keyExtractor(item)}
                        layout
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.8 }}
                        transition={{ duration: 0.2 }}
                    >
                        {renderItem(item)}
                    </motion.div>
                ))}
            </AnimatePresence>
        </div>
    );
} 